import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px 18px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;

  div {
    width: 100%;
  }
`;

export const Bottom = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 24px;

  div + div {
    margin-left: 18px;
  }
`;

export const Both = styled.div`
  clear: both;
`;
